//import correios from '../api/correios';
import session from '../api/session';

import router from '../router';

const CART_STORAGE_KEY = 'SDT_MEDIA_CART';
const MAX_CART_SIZE = 200;

//import FaixaPreco from '@/settings/prices.json';

const checkDisks = (media) => {
  return ( media.discos !== null && !media.preco ) ? media.discos : ( !media.preco ) ? 1 : 0;
};

const groupBy = (items, key) => items.reduce(
    (result, item) => ({
      ...result,
      [item[key]]: [
        ...(result[item[key]] || []),
        item,
      ],
    }), 
    {},
);

export default {
  namespaced: true,
  state: {
    items: ( CART_STORAGE_KEY in localStorage ) ? localStorage.getObject(CART_STORAGE_KEY) : [],
    shipping_address: null,
    shipping_cost: null,
    shipping_delivery_time: null,
    cart_item_exists: false,
    add_media_complete: false,
    remove_media_error: false,
    order: null,
    precos: null,
    taxas: 0.00
  },
  getters: {
    sacolaTitulos: state => {
        return state.items.slice().reverse()
    },
    sacolaTitulosRegular: state => {
      return state.items.filter(media => !media.preco).reverse()
    },
    sacolaTitulosGold: state => {
      return state.items.filter(media => media.preco !== null).reverse()
    },
    orderState: state => {
        return state.order
    },
    sacolaTitulosAgrupada: (state, getters) => {
        let _cart = getters.sacolaTitulosRegular;
        return groupBy(_cart,'titulo');
    },
    sacolaTitulosAgrupadaGold: (state, getters) => {
      let _cart = getters.sacolaTitulosGold;
      return groupBy(_cart,'titulo');
    },
    sacolaCheia: state => {
      return state.items.length >= MAX_CART_SIZE
    },
    orderTotalDisks: (state, getters) => {
      const total = getters.sacolaTitulosRegular.reduce((acc, media) => acc + checkDisks(media), 0);
      return total;
    },
    getPriceRange: (state, getters) => {
      const discos = getters.orderTotalDisks;
      if ( !state.precos ) {
        return 0.00;
      }
      let faixaPreco = state.precos.filter(preco => 
        ( preco.max ) ? preco.min <= discos && preco.max >= discos : preco.min <= discos );
      return faixaPreco[0];
    },
    orderTaxes: state => {
      return state.taxas
    },
    orderShipping(state, getters) {
      const priceRange = getters.getPriceRange;
      const freteGratis = priceRange.frete_gratis;
      const freteValue = state.shipping_cost;
      if ( freteValue && freteGratis !== true ) {
        return freteValue;
      }else{
        return ( freteGratis == true ) ? 'Grátis' : null;
      }
    },
    orderSubTotal(state, getters){
      const priceRange = getters.getPriceRange;
      const valorUnitario = priceRange.valor;
      const discos = getters.orderTotalDisks;
      const subTotalRegular = discos * valorUnitario;
      /* adicionando dublagens gold */
      const subTotalGold = getters.sacolaTitulosGold.reduce((acc, media) => acc + parseFloat(media.preco), 0);
      const subTotal = parseFloat(subTotalRegular + subTotalGold);
      return subTotal;
    }, 
    orderTotal(state, getters){
      const subTotal = getters.orderSubTotal;
      const freteValue = state.shipping_cost;
      /* adicionando taxa boleto */
      const subTotalTaxes = getters.orderTaxes;
      const totalOrder = parseFloat(subTotal + subTotalTaxes + freteValue);
      return Number(totalOrder.toFixed(2));
    },
  },
  actions: {
    addMedia({ commit }, payload) {
      commit('addMedia', payload);
      return commit('updateCartState');
    },
    removeMedia({ commit }, payload) {
      commit('removeMedia', payload);
      return commit('updateCartState');
    },
    emptyCart({ commit }) {
      commit('cleanCart');
      return commit('updateCartState');
    },
    updateCartState({ commit }) {
      return commit('updateCartState');
    },
    updateShipping({ commit }, payload) {
      commit('updateShippingAddress', payload.endereco);
      commit('updateShippingDelivery', payload.prazo);
      return commit('updateShippingPrice', payload.valor);
    },
    updateTaxes({ commit }, value) {
      return commit('updateTaxes',value);
    },
    checkCartItemToCheckout({ commit, getters }) {
      let check = (Object.keys(getters.sacolaTitulos).length <= 1) ? true : false;
      if (check == false) {
        return router.push('/checkout');
      }else{
        let warnModal = {
          title: 'Dublagem única',
          body: 'Você só possui uma dublagem em seu carrinho, não quer aproveitar e incluir mais dublagens?',
          classe: '',
          icon: 'fa fa-times-circle',
          okButton: 'Finalizar',
          closeBtnLabel: 'Voltar',
          okAction: '/checkout',
          okType: 'success outline',
          closeBtnType: 'link',
        };
        return this.dispatch('modal/invokeStateModal',warnModal);
      }
    },
    loadFaixaPreco({ commit }) {
      session.get('/v1/prices/').then(response => {
        let payload = response.data;
        return commit('updateFaixaPreco', payload);
      });
    },
    createOrder({ commit }, payload){
      commit('startOrder');
      return session.post('/v1/order/', payload);    
    },
    finishOrder({ commit }, order){
      return commit('loadOrder',order);
    },
    loadOrder({ commit }, order){
      session.get('/v1/order/'+order+'/').then(response => {
        const order_obj = response.data;
        let _media = order_obj.midias.slice().reverse();
        order_obj.midias = groupBy(_media,'titulo');
        return commit('loadOrder',order_obj);
      }).catch(err => {
        // os únicos erros plausíveis aqui são unauthorized ou not found, redirecionar pros pedidos.
        router.push('/perfil/pedidos');
      });
    },
    verifyCheckoutStatus() {
      return session.get('/v1/checkout/status');
    },
  },
  mutations: {
    startOrder(state){
      state.order_id = null;
    },
    loadOrder(state, order){
      return new Promise((resolve, reject) => {
        state.order = order;
        resolve()
      });
    },
    orderError(state){
      state.order_id = null;
    },
    updateFaixaPreco(state, payload){
      state.precos = payload;
    },
    updateShippingDelivery(state, days){
      state.shipping_delivery_time = days; 
    },
    updateShippingPrice(state, price){
      state.shipping_cost = price; 
    },
    updateShippingAddress(state, address){
      state.shipping_address = address;
    },
    updateTaxes(state, amount){
      state.taxas = amount;
    },
    addMedia(state, payload) {
      return new Promise((resolve, reject) => {
        state.add_media_complete = false;
        state.cart_item_exists = false;
        if ( state.items.length < MAX_CART_SIZE ) {
          if ( typeof payload === 'object') {
            payload.forEach(item => {
              const _id = item.id;
              /* Utilizando função ES6 para verificar se o filme já existe na sacola */
              let existe = state.items.some(media => media.id === _id);
              if ( existe == false && state.items.length < MAX_CART_SIZE ){
                state.items.push(item);
              } else {
                state.cart_item_exists = true;
              }
            });
            state.add_media_complete = true;
            resolve()
          }
        }
      })
    },
    removeMedia(state, payload) {
      state.remove_media_error = false;
      if ( typeof payload === 'object') {
        let _items = state.items;
        payload.forEach(item => {
          _items = _items.filter(midia => midia.id !== item.id);
        })
        state.items = _items;
      }else {
        state.remove_media_error = true;
      }
    },
    cleanCart(state) {
      state.items = [];
    },
    updateCartState(state) {
      localStorage.setObject(CART_STORAGE_KEY, state.items);
    },
  }
};
